import {Component , Inject , OnInit , ViewEncapsulation} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {GroupService} from "../../../../../core/services/group.service";
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'target-group-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class TargetGroupFormDialogComponent implements OnInit {
  public formGroup: FormGroup = new FormGroup({
    ageMask: new FormControl('', Validators.required),
    targetNumber: new FormControl('', Validators.required),
    abbreviation: new FormControl(''),
    groupId: new FormControl(''),
    showInFront: new FormControl('')
  });
  action: string;
  dialogTitle;
  eventType;
  targetGroups: any;
   constructor (public dialogRef: MatDialogRef<TargetGroupFormDialogComponent> ,
               @Inject(MAT_DIALOG_DATA) private data: any ,
                public groupService: GroupService,
               public translate: TranslateService) {
    this.action = data.action;
    if (this.action === 'edit') {
      this.dialogTitle = 'targetGroup.edit';
      this.eventType = data.type;
    }
    else {
      this.dialogTitle = 'targetGroup.new';
    }
  }

  ngOnInit () {
    this.groupService.getGroups().then((result: any) => {
      this.targetGroups = result;
      if (this.action === 'edit') {
        this.formGroup.patchValue(this.eventType);
      }
    });
  }
}
